import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import Popup from '../helpers/Popup';
import FetchingError from '../helpers/FetchingError';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';
import AutoComplete from '../helpers/AutoComplete';
import Input from '../helpers/Input';

const AddNewPlatformProjectPopup = props => {
  const {
    onCreate,
    onClose,
    onChange,
    harvcoLeadSuggestions,
    clientLeadSuggestions,
    executiveSuggestions,
    formData,
    isPopupFetching,
    isPopupFetchingError,
  } = props;
  const header = 'Create a new platform project';
  const disableCreate = !formData.get('category');
  const footer = (
    <>
      <Button key="create" className="btn-primary" disabled={disableCreate} onClick={onCreate}>
        Create
      </Button>
      <Button key="close" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="setNextActionPopup" loading={isPopupFetching}>
      <div className="row">
        <FormGroup className="col-xs-12">
          <Input
            className="input-md"
            id="category"
            label="Category"
            name="category"
            onChange={onChange}
            placeholder=""
            autoFocus
            showLabel
          />
        </FormGroup>
      </div>
      <div className="row">
        <AutoComplete {...harvcoLeadSuggestions} formGroupClass="col-xs-4" />
        <AutoComplete {...clientLeadSuggestions} formGroupClass="col-xs-4" />
        <AutoComplete {...executiveSuggestions} formGroupClass="col-xs-4" />
      </div>
      <FetchingError error={isPopupFetchingError} />
    </Popup>
  );
};

AddNewPlatformProjectPopup.propTypes = {
  clientLeadSuggestions: PropTypes.object.isRequired,
  executiveSuggestions: PropTypes.object.isRequired,
  formData: PropTypes.instanceOf(Map).isRequired,
  harvcoLeadSuggestions: PropTypes.object.isRequired,
  isPopupFetching: PropTypes.bool,
  isPopupFetchingError: PropTypes.instanceOf(Map),
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default memo(AddNewPlatformProjectPopup);
